module.exports = __webpack_public_path__ + "static/25-ec2111d99703ff2c1dfdc3bd3b6db538.jpg";